import { fetchWebsite } from '../utils/api/website.utils';
import { WebsiteState } from './website.types';

export type WebsiteConfiguration = {
  dataSources: any[];
  assets: any[];
  styles: any[];
  pages: any[];
  symbols: any[];
  totalPages: number;
};

export class Website {
  public id: string;
  public organizationId: string;
  public title: string;
  public subdomain: string;
  public searchEngineVisibility: boolean;
  public lastPublishedAt: Date;
  public draft: WebsiteConfiguration;
  public published: WebsiteConfiguration;

  constructor(params: {
    id: string;
    organizationId: string;
    title: string;
    subdomain: string;
    searchEngineVisibility?: boolean;
    lastPublishedAt?: Date;
    draft: WebsiteConfiguration;
    published: WebsiteConfiguration;
  }) {
    this.id = params.id;
    this.organizationId = params.organizationId;
    this.title = params.title;
    this.subdomain = params.subdomain;
    this.searchEngineVisibility = params.searchEngineVisibility ?? false;
    this.lastPublishedAt = params.lastPublishedAt ?? new Date();
    this.draft = params.draft;
    this.published = params.published;
  }

  isSearchEngineVisible(): boolean {
    return this.searchEngineVisibility;
  }

  getDraftConfiguration(): WebsiteConfiguration {
    return this.draft;
  }

  getPublishedConfiguration(): WebsiteConfiguration {
    return this.published;
  }

  static fromObject(obj: any): Website {
    return new Website({
      id: obj.id,
      organizationId: obj.organizationId,
      title: obj.title,
      subdomain: obj.subdomain,
      searchEngineVisibility: obj.searchEngineVisibility,
      lastPublishedAt: new Date(obj.lastPublishedAt),
      draft: obj.draft,
      published: obj.published,
    });
  }

  static async fromId(websiteId: string): Promise<Website> {
    return await fetchWebsite(websiteId);
  }

  toObject(): any {
    return {
      id: this.id,
      organizationId: this.organizationId,
      title: this.title,
      subdomain: this.subdomain,
      searchEngineVisibility: this.searchEngineVisibility,
      lastPublishedAt: this.lastPublishedAt.toISOString(),
      draft: this.draft,
      published: this.published,
    };
  }

  getHtml(websiteState: WebsiteState, pageIndex: number = 0): string {
    return this[websiteState ?? 'published'].pages[pageIndex]?.html ?? '';
  }
}
